var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inpatient-information"},[_vm._v("住院人信息")])}
var staticRenderFns = []

export { render, staticRenderFns }